import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import Home from '@/components/Home'
import DemoController from '@/components/demos/DemoController'
import DemoScroll from '@/components/demos/DemoScroll'
import DemoMotion from '@/components/demos/DemoMotion'
import DemoTerrain from '@/components/demos/DemoTerrain'
import Report from '@/components/report/Report'
import Page from '@/components/report/Page'
import { reportData } from '@/lib/consts'

Vue.use( Router )

const ROUTER = new Router( {
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/demos',
      props: true,
      component: DemoController,
      children: [
        {
          path: '',
          redirect: { name: 'motion' }
        },
        {
          path: 'motion',
          name: 'motion',
          component: DemoMotion
        },
        {
          path: 'scroll',
          name: 'scroll',
          component: DemoScroll
        },
        {
          path: 'terrain',
          name: 'terrain',
          component: DemoTerrain
        }
      ]
    },
    {
      path: '/report',
      component: Report,
      children: [
        { path: '', component: Page, redirect: '0' },
        {
          path: ':idx',
          component: Page,
          props: route => {
            let idx = parseInt( route.params.idx, 10 )
            return {
              data: reportData[ idx ],
              idx: idx,
              footer: idx >= (reportData.length - 1) ? false : {
                subhead: reportData[ idx + 1 ].footSub,
                keyword: reportData[ idx + 1 ].keyword,
                numeral: reportData[ idx + 1 ].numeral
              }
            }
          }
        }
      ]
    }
  ],
  scrollBehavior ( to, from, savedPos ) {
    return to.path.includes( 'report' ) ? { x: 0, y: 0 } : savedPos || { x: 0, y: 0 }
  }
} )

ROUTER.beforeEach( ( to, from, next ) => {
  if ( to.name !== 'home' && !store.state.didViewHome ) {
    next( '/' )
  } else if ( to.path.indexOf( 'demos' ) >= 0 && !store.state.demoCapable ) {
    next('/report')
  } else if ( to.path.indexOf( 'report') >= 0 ) {
    store.dispatch( 'setSideNavActiveIdx', parseInt( to.params.idx ) )
    next()
  } else {
    next()
  }
} )

export default ROUTER



// WEBPACK FOOTER //
// ./src/router/index.js